





















































































import { ActiveOrderConfiguration, OrderWidgetConfigurationItem } from '@a/store/landingpage/types';
import { DropdownGroup, DropDownItem } from '@c/ui/select/types/dropdownItem';
import RegionSwitcherModal from '../../../footer/RegionSwitcherModal.vue';
import DropdownInputElement from '../../../ui/form/elements/DropdownInputElement.vue';
import {
  computed, defineComponent, PropType, reactive, Ref, ref,
} from '@vue/composition-api';
import { useI18N } from '@a/composables/use-vue-i18n';

import {
  getDefaultLocationDropdownItem,
  getFormattedRamByUnitsAndLocale,
  groupOrderConfigurationByRegion,
  hasOrderConfigurationActiveLocations,
} from '../OrderWidgetFeatures';
import { useConfigurationApi } from '@a/plugins/configuration';
import OrderWidgetBoxSlots from './OrderWidgetBoxSlots.vue';
import OrderWidgetBoxRam from './OrderWidgetBoxRam.vue';
import { useAsset } from '@a/plugins/assets';
import { CloudUnitTypeName, ProductServerLocation } from '@a/store/product/types';
import OrderNowButton from '../../OrderNowButton.vue';
import i18next from 'i18next';

export default defineComponent({
  name: 'OrderWidgetBox',
  components: {
    DropdownInputElement,
    RegionSwitcherModal,
    OrderWidgetBoxSlots,
    OrderWidgetBoxRam,
    OrderNowButton,
  },
  created: async () => {
    await i18next.loadNamespaces('extension');
  },
  emits: [
    'click:orderwidget',
  ],
  props: {
    widgetItem: {
      required: true,
      type: Object as PropType<OrderWidgetConfigurationItem>,
    },
    widgetIndex: {
      required: false,
      default: -1,
      type: Number,
    },
    widgetOpen: {
      required: false,
      default: false,
      type: Boolean,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  setup: (props, { emit }) => {
    const i18n = useI18N();
    const asset = useAsset();
    const configurationApi = useConfigurationApi();
    const orderWidgetForm: Ref<HTMLFormElement> = ref(null);
    const { units, duration } = props.widgetItem;

    const soldOutTitle = i18n.t('payment:checkout.sold_out');

    const state = reactive({
      showRegionModal: false,
      selectedItem: getDefaultLocationDropdownItem(
        {
          region: configurationApi.data.routes.regionPrefix,
          locale: configurationApi.data.routes.localePrefix,
        },
        props.widgetItem.locations,
        soldOutTitle,
      ) as DropDownItem<string>,
      currentLocation: computed((): ProductServerLocation => props.widgetItem.locations.find(
        (location: ProductServerLocation) => location.key === state.selectedItem.value,
      )),
      dropdownItems: computed((): Array<DropdownGroup<string>> => groupOrderConfigurationByRegion(
        props.widgetItem,
        state.currentLocation,
        {
          soldOutTitle: i18n.t('payment:checkout.sold_out'),
          currentServerRegionTitle: i18n.t('landingpage:orderwidget.group.current_server_region'),
          otherServerRegionTitle: i18n.t('landingpage:orderwidget.group.other_server_region'),
        },
      )),
      hasOtherLocations: computed((): boolean => hasOrderConfigurationActiveLocations(
        groupOrderConfigurationByRegion(props.widgetItem, state.currentLocation, soldOutTitle),
      )),
      orderWidgetStyle: computed(
        () => ({
          backgroundImage: props.widgetItem.backgroundImage != null
            ? `url('${props.widgetItem.backgroundImage}')` : undefined,
        }),
      ),
    });

    const onOrderWidgetClick = () => {
      emit('click:orderwidget', {
        units,
        duration,
        currentLocation: state.currentLocation,
      } as ActiveOrderConfiguration);
    };

    return {
      units,
      duration,
      orderWidgetForm,
      state,
      i18n,
      asset,
      getFormattedRamByUnitsAndLocale,
      onOrderWidgetClick,
      CLOUD_UNIT_TYPE_SLOT: CloudUnitTypeName.SLOT,
      CLOUD_UNIT_TYPE_RAM: CloudUnitTypeName.GB,
    };
  },
});
